import React from 'react';
import { bool, array, func } from 'prop-types';
import Card from '../Card/Card';
import PaymentPursesListItem from './PaymentPursesListItem/PaymentPursesListItem';
import Contracts from '../../themes/3/components/Contracts/Contracts';
import { FMessage, ThemedFMessage } from '../../hoc/IntlComponents';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

const propTypes = {
  wallets: array.isRequired,
  onSavePurse: func.isRequired,
  loading: bool,
};

const defaultProps = {
  wallets: [],
};

const maxWalletsForMultiple = 5;

// @see pages/payment/PaymentDataPage.js:217 (три файла вместе с темами), поиск по: 1, 3, 4, 5, 11, 15, 29, 30
const walletsOrder = [1, 15, 27, 3, 30, 37, 5, 4, 11, 28, 29, 36, 31, 32, 33, 34, 35, 41, 42, 43];

const PaymentPursesList = ({
  wallets,
  loading,
  onSavePurse,
  onDeletePurse,
  // onEditCard,
  intl,
  newWalletSMSInputTargetId,
  handleChangeNewWalletSMSInputTargetId,
  handleSubmitWithSMS,
  handleValidate,
  clearRedirectToPaymentsData,
  submitCatchCB,
  submitThenCB,
  profile,
  showAlert,
  closeAlert,
  getWallets,
  theme,
  isMember,
  redirectToPaymentsData,
}) => {
  const sortWalletsByType = () => {
    const sortedWallets = [];
    walletsOrder.forEach((type) => {
      wallets.forEach((wallet) => {
        // if (type === wallet.type) {
        if (type === wallet.type && wallet.type === 29) {
          sortedWallets.push(wallet);
        }
      });
    });
    return sortedWallets;
  };

  return (
    <Card loading={loading}>
      <Card.Body>
        {sortWalletsByType(wallets).map((wallet) => (
          <PaymentPursesListItem
            theme={theme}
            key={wallet.type}
            {...wallet}
            onSavePurse={onSavePurse}
            onDeletePurse={onDeletePurse}
            // onEditCard={onEditCard}
            maxWalletsForMultiple={maxWalletsForMultiple}
            intl={intl}
            newWalletSMSInputTargetId={newWalletSMSInputTargetId}
            handleChangeNewWalletSMSInputTargetId={handleChangeNewWalletSMSInputTargetId}
            handleSubmitWithSMS={handleSubmitWithSMS}
            handleValidate={handleValidate}
            clearRedirectToPaymentsData={clearRedirectToPaymentsData}
            submitCatchCB={submitCatchCB}
            submitThenCB={submitThenCB}
            profile={profile}
            showAlert={showAlert}
            closeAlert={closeAlert}
            isMember={isMember}
            getWallets={getWallets}
            redirectToPaymentsData={redirectToPaymentsData}
          />
        ))}
      </Card.Body>
    </Card>
  );
};

PaymentPursesList.propTypes = propTypes;
PaymentPursesList.defaultProps = defaultProps;

export default PaymentPursesList;
